import { B as d, d as E, D as S, F as f, c as h, H as g, L as M, N as j, P as T, e as p, S as P, g as C, f as D, h as I, T as b, i as k, V as w, Y as L, a as y, b as O, s as F, t as H } from "./TrailingNode-RUZKVwzB.js";
import { _ as i } from "./defaultBlocks-BtXm8wl3.js";
import { a8 as N, a9 as Y, ac as _, ab as v, aa as B } from "./defaultBlocks-BtXm8wl3.js";
import { S as U } from "./ShowSelection-Dz-NEase.js";
let o;
async function r() {
  return o || (o = (async () => {
    const [e, n] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), a = "default" in e ? e.default : e, t = "default" in n ? n.default : n;
    return await a.init({ data: t }), { emojiMart: a, emojiData: t };
  })(), o);
}
async function c(e, n) {
  if (!("text" in e.schema.inlineContentSchema) || e.schema.inlineContentSchema.text !== i.text)
    return [];
  const { emojiData: a, emojiMart: t } = await r();
  return (n.trim() === "" ? Object.values(a.emojis) : await t.SearchIndex.search(n)).map((s) => ({
    id: s.skins[0].native,
    onItemClick: () => e.insertInlineContent(s.skins[0].native + " ")
  }));
}
export {
  d as BlockChangeExtension,
  E as DEFAULT_LINK_PROTOCOL,
  S as DropCursorExtension,
  N as FilePanelExtension,
  f as ForkYDocExtension,
  h as FormattingToolbarExtension,
  g as HistoryExtension,
  M as LinkToolbarExtension,
  j as NodeSelectionKeyboardExtension,
  T as PlaceholderExtension,
  p as PreviousBlockTypeExtension,
  P as SchemaMigration,
  U as ShowSelectionExtension,
  C as SideMenuExtension,
  D as SideMenuView,
  Y as SuggestionMenu,
  I as TableHandlesExtension,
  b as TableHandlesView,
  k as TrailingNodeExtension,
  w as VALID_LINK_PROTOCOLS,
  L as YCursorExtension,
  y as YSyncExtension,
  O as YUndoExtension,
  _ as filterSuggestionItems,
  c as getDefaultEmojiPickerItems,
  v as getDefaultSlashMenuItems,
  B as insertOrUpdateBlockForSlashMenu,
  F as sideMenuPluginKey,
  H as tableHandlesPluginKey
};
//# sourceMappingURL=extensions.js.map
